import { contacts } from 'containers/Contact/data';
import { v4 as uuid } from 'uuid';
import {
  BlockOfCommunicating,
  CommunicatingAddressText,
  ContactInformation,
  ContactText,
  GmailLocationPhone,
  IconsForContact,
} from './styled';

export const Information = () => (
  <ContactInformation>
    <ContactText>Contact Information</ContactText>

    <GmailLocationPhone>
      {contacts.map((item) => (
        <BlockOfCommunicating key={uuid()}>
          <IconsForContact src={item.icon} />
          <CommunicatingAddressText>{item.content}</CommunicatingAddressText>
        </BlockOfCommunicating>
      ))}
    </GmailLocationPhone>

    {/*<SocialMediaIcons>*/}
    {/*  {icons.map((item) => (*/}
    {/*    <LinkToWebsite key={uuid()} href={item.link} target="_blank" rel="noreferrer">*/}
    {/*      <IconImage src={item.img} />*/}
    {/*    </LinkToWebsite>*/}
    {/*  ))}*/}
    {/*</SocialMediaIcons>*/}
  </ContactInformation>
);
